import React from "react";
import {  Redirect } from "react-router-dom";
import {  observer } from "mobx-react-lite";
import {useStores} from "../hooks/use-stores";
import {useLocation} from "react-router";
import { getCookie, setCookie } from "../utils/cookieUtil";

export default (observer(({ component: C, ...rest }) => {
    const location = useLocation()
    let redirect = new URLSearchParams(location.search).get("redirect")
    const {authStore, commonStore } = useStores()
    const {currentUser} = authStore;


    if ( currentUser ) {
        const { country } = currentUser;
        const welcomeCookie = getCookie(`welcome_shown_${currentUser.userID}`)
        if ( commonStore.onStarfishOrRoyalStarfish && authStore.currentUser.UserApprovedKYC === false
            && !welcomeCookie &&  country === 'US'  )
        {
            commonStore.showKYCPopup()
            setCookie(`welcome_shown_${currentUser.userID}`, true, 10000 )
            console.log(commonStore.kycPopup)
        }
        console.log("redirect", redirect)
        return <Redirect
            to={redirect === "" || redirect === null ? "/" : redirect}
        />
    }
    else
        return  <C {...rest} />


}))